import React from 'react';

function Blog() {
  return (
    <div className="flex items-center justify-center h-screen bg-gray-900">
      <h1 className="text-white text-3xl">Blog</h1>
    </div>
  );
}

export default Blog;
